// Car photos are stored as JPG (cars.json) plus WebP versions generated by
// scripts/make-webp.js: 01.jpg -> 01.webp (up to 1600px) and 01-800.webp (up to 800px).
export const webpLarge = (jpg) => jpg.replace(/\.jpg$/, ".webp");
export const webpSmall = (jpg) => jpg.replace(/\.jpg$/, "-800.webp");
// srcset for the big photo on the car page: the browser picks 800px or 1600px.
export const webpSrcSet = (jpg) => `${webpSmall(jpg)} 800w, ${webpLarge(jpg)} 1600w`;
export const MAIN_PHOTO_SIZES = "(max-width: 900px) 100vw, 640px";
